(() => {
  const banner = document.querySelector('.rotating-announcement');
  if (!banner) return;
  const messages = [...banner.querySelectorAll('.announcement-message')];
  const toggle = banner.querySelector('.announcement-toggle');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = 0, paused = reduced.matches, hovering = false, timer;
  const sync = () => {
    clearInterval(timer);
    toggle.textContent = paused ? '▷' : 'Ⅱ';
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
    if (!paused && !hovering && !document.hidden) timer = setInterval(() => {
      messages[active].classList.remove('is-active');
      active = (active + 1) % messages.length;
      messages[active].classList.add('is-active');
    }, 4000);
  };
  toggle.addEventListener('click', () => { paused = !paused; sync(); });
  banner.addEventListener('mouseenter', () => { hovering = true; sync(); });
  banner.addEventListener('mouseleave', () => { hovering = false; sync(); });
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', () => { paused = reduced.matches; sync(); });
  sync();
})();
